import React from 'react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';

import Grid from '~/components/core/Atomic/Grid/Grid';
import SwitchFormik from '~/components/core/Formik/SwitchFormik';
import TextFieldFormik from '~/components/TextFieldFormik';

import {
  CLIVE_ADDITIONAL_INSTRUCTIONS_FIELD_KEY,
  CLIVE_EXCLUDED_FIELD_KEY,
  useCliveConfigOptions,
} from './CliveConfigurationContext';

interface CliveObjectConfigProps {
  basePath: string;
}

const CliveObjectConfig: React.FC<CliveObjectConfigProps> = ({ basePath }) => {
  const { showCliveConfigOptions } = useCliveConfigOptions();
  const { values } = useFormikContext();
  const isCliveExcluded = get(values, `${basePath}.${CLIVE_EXCLUDED_FIELD_KEY}`, false);

  if (!showCliveConfigOptions) {
    return null;
  }

  return (
    <>
      <Grid item xs={12}>
        <SwitchFormik
          id={`${basePath}.${CLIVE_EXCLUDED_FIELD_KEY}`}
          label="Exclude from Clive Auto-Fill"
          hideErrorGap
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldFormik
          id={`${basePath}.${CLIVE_ADDITIONAL_INSTRUCTIONS_FIELD_KEY}`}
          label="Clive additional instructions"
          fullWidth
          multiline
          rows={3}
          disabled={isCliveExcluded}
        />
      </Grid>
    </>
  );
};

export default CliveObjectConfig;
